var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import CompanyStore from 'stores/CompanyStore/store';
import { logoutMobile } from 'actions/ServerActionCreators';
import { Roles, UploadTypes } from 'constants/AdminConstants';
import { getUploadUrl } from 'utils/UploadUtils';
import toNumberOrNull from 'utils/NumberUtils';
import ProducerKnockSurface from '../shared/producerFeed/ProducerKnockSurface';
import CoachKnockFeed from '../headerComponents/CoachKnockFeed';
var getStateFromStores = function () { return CompanyStore.getCurrentUser(); };
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showMenu: false,
            currentUser: getStateFromStores()
        };
        _this.onChangeHandler = _this.onChangeHandler.bind(_this);
        _this.toggleMenu = _this.toggleMenu.bind(_this);
        _this.logout = _this.logout.bind(_this);
        return _this;
    }
    Header.prototype.componentDidMount = function () {
        CompanyStore.addChangeListener(this.onChangeHandler);
    };
    Header.prototype.componentWillUnmount = function () {
        CompanyStore.removeChangeListener(this.onChangeHandler);
    };
    Header.prototype.onChangeHandler = function () {
        this.setState({ currentUser: getStateFromStores() });
    };
    Header.prototype.getMenu = function () {
        var clickLayerStyle = {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgb(0,0,0)',
            opacity: 0,
            overflowY: 'scroll',
            zIndex: 98,
            width: '100%',
            height: '100%'
        };
        var userName = '';
        if (this.state.currentUser) {
            userName = this.state.currentUser.user_name || '';
        }
        if (!this.state.showMenu) {
            return '';
        }
        return (_jsxs("div", { children: [_jsxs("div", { className: "dropdown pad  logged-in-user-dropdown is-visible", id: "logged_in_user_dropdown", children: [_jsx("div", { className: "pad text-center", children: _jsx("span", { className: "logged-in-user-name", children: userName }) }), _jsxs("div", { className: "g", children: [_jsx("div", { className: "u-md-6 u-sm-6 text-center", children: _jsxs("a", { href: "https://www.scoreboardbuzz.com", className: "button--link button--small", children: [_jsx("i", { className: "icon ion-gear-a" }), ' ', "Full site"] }) }), _jsx("div", { className: "u-md-6 u-sm-6 text-center", children: _jsxs("button", { type: "button", className: "button--link button--small", onClick: this.logout, children: [_jsx("i", { className: "icon ion-android-exit" }), ' ', "Log Out"] }) })] })] }), _jsx("div", { className: "click-layer", style: clickLayerStyle, onClick: this.toggleMenu })] }));
    };
    Header.prototype.logout = function (event) {
        event.preventDefault();
        this.toggleMenu();
        logoutMobile();
    };
    Header.prototype.toggleMenu = function () {
        this.setState(function (state) {
            return __assign(__assign({}, state), { showMenu: !state.showMenu });
        });
    };
    Header.prototype.render = function () {
        var _a;
        var uploadUrl = '';
        if (this.state.currentUser) {
            uploadUrl = this.state.currentUser.upload_url || '';
        }
        var imageUrl = getUploadUrl(uploadUrl, UploadTypes.UPLOAD_TYPE_USER);
        var roleId = toNumberOrNull((_a = this.state.currentUser) === null || _a === void 0 ? void 0 : _a.role_id);
        return (_jsxs("div", { className: "sb-app-header", children: [_jsx("img", { className: "sb-app-logo", src: "/img/mobile/logo_black.svg", alt: "ScoreboardBuzz" }), _jsxs("div", { className: "logged-in-user  has-dropdown  pull-right pad-right", children: [_jsx("div", { className: "logged-in-user-pic", onClick: this.toggleMenu, children: _jsx("img", { src: imageUrl, alt: "User Pic" }) }), this.getMenu()] }), _jsx("div", { className: "pull-right flex h-full items-center", children: roleId === Roles.SALESPERSON ? (_jsx(ProducerKnockSurface, { page: "mobile" })) : (_jsx(CoachKnockFeed, { page: "mobile" })) })] }));
    };
    return Header;
}(React.Component));
export default Header;
